import Vue from 'vue'
import router from './router'
import store from './store'
import vuetify from '@/plugins/vuetify'
import i18n from '@/plugins/i18n'
import VueErrorHandler from './VueErrorHandler'
import Notification from '@/plugins/notification'
import gtm from '@/plugins/gtm'
import VuePersianDatetimePicker from './plugins/vue-persian-datetime-picker'
import vuePrototype from './vuePrototype'
import App from './App';

Vue.config.productionTip = false
Vue.config.errorHandler  = VueErrorHandler

const Appvue = new Vue({
    router,
    store,
    vuetify,
    Notification,
    vuePrototype,
    i18n,
    VuePersianDatetimePicker,
    gtm,
    render: h => h(App)
}).$mount('#app');

export default Appvue
